import { useLogout } from '@refinedev/core';
import { useEffect, useRef } from 'react';
import PageLoader from 'src/UI/loader/PageLoader';
import { Logger } from 'src/utils/Logger';

export function LogoutPage() {
  const hasLoggedOut = useRef(false);
  const { mutate: logout } = useLogout({
    mutationOptions: {
      onError: error => {
        Logger.error('Logout failed', error);
        window.location.replace('/login');
      },
    },
  });

  useEffect(() => {
    if (!hasLoggedOut.current) {
      hasLoggedOut.current = true;
      logout();
    }
  }, [logout]);

  return <PageLoader />;
}
